import _ from "lodash";
import dateFormat from "dateformat";
import {
    INSTAGRAM_POST_SCHEDULE_LIST,
    LOGO_IMAGE_DETAIL,
    PRODUCT_IMAGE_DETAIL,
    SHOPIFY_PRODUCT_IMAGES_PATH
} from "../constants/shopify.constant";
import {prepareProductInstagramPost} from "../../social/instagram/instagram-shopify-product-util";

export {
    applyBulkPostSchedule,
}

const applyBulkPostSchedule = (settings, productList) => {
    const postFrequency = settings.postFrequency;

    if (postFrequency === 'same-day-time') {
        prepareSameDayTimeSchedule(settings, productList);
    } else if (postFrequency === 'same-day-every-time') {
        prepareSameDayEveryTimeSchedule(settings, productList);
    } else if (postFrequency === 'every-day-same-time') {
        prepareEveryDaySameTimeSchedule(settings, productList);
    } else if (postFrequency === 'every-day-time') {
        prepareEveryDayTimeSchedule(settings, productList);
    }
}

const prepareSameDayTimeSchedule = (settings, productList) => {
    _.forEach(productList, (product, index) => {
        if (product.settings && product.settings.imagesUploaded) {
            product.settings.postDate = settings.postDate;
            product.settings.postTime = settings.postTime;

            // console.log(product.settings.postDate, product.settings.postTime);
            prepareInstagramPostStatus(product);
        }
    });
}

const prepareSameDayEveryTimeSchedule = (settings, productList) => {
    const postScheduleList = INSTAGRAM_POST_SCHEDULE_LIST;

    _.forEach(productList, (product, index) => {
        if (product.settings && product.settings.imagesUploaded) {
            product.settings.postDate = settings.postDate;

            // @ts-ignore
            const scheduleIndex = index % postScheduleList.length;
            const postTimeDetail = postScheduleList[scheduleIndex];
            product.settings.postTime = postTimeDetail.key;

            // console.log(product.settings.postDate, product.settings.postTime);
            prepareInstagramPostStatus(product);
        }
    });
}

const prepareEveryDaySameTimeSchedule = (settings, productList) => {
    _.forEach(productList, (product, index) => {
        if (product.settings && product.settings.imagesUploaded) {
            // @ts-ignore
            product.settings.postDate = dateFormat(new Date(new Date(settings.postDate).setDate(new Date(settings.postDate).getDate() + index)), 'isoDate');
            product.settings.postTime = settings.postTime;

            // console.log(product.settings.postDate, product.settings.postTime);
            prepareInstagramPostStatus(product);
        }
    });
}

const prepareEveryDayTimeSchedule = (settings, productList) => {
    const postScheduleList = INSTAGRAM_POST_SCHEDULE_LIST;

    _.forEach(productList, (product, index) => {
        if (product.settings && product.settings.imagesUploaded) {
            // @ts-ignore
            product.settings.postDate = dateFormat(new Date(new Date(settings.postDate).setDate(new Date(settings.postDate).getDate() + index)), 'isoDate');

            // @ts-ignore
            const scheduleIndex = index % postScheduleList.length;
            const postTimeDetail = postScheduleList[scheduleIndex];
            product.settings.postTime = postTimeDetail.key;

            // console.log(product.settings.postDate, product.settings.postTime);
            prepareInstagramPostStatus(product);
        }
    });
}


const prepareInstagramPostStatus = (product) => {
    // product.instagramPost = prepareProductInstagramPost(product);
    product.instagramPost = {};

    if (product?.instagramPost && product.settings?.postDate && product.settings?.postTime) {
        if (!product?.instagramPost?.status || product?.instagramPost?.status !== 'Published') {
            product.instagramPost.status = 'Scheduled';
        }
    }
}
